import { createContext, createRef, RefObject, useContext } from 'react';

export const PopoverRelativeElementContext = createContext(createRef<Element | null>());

export const usePopoverRelativeElement = <T extends Element = Element>(): RefObject<T> => useContext(PopoverRelativeElementContext) as RefObject<T>;
